module.exports = __webpack_public_path__ + "img/fr.f648d7b5.png";